import axios from './index';

export const createOrUpdatePasswordAPI = (data) => {
    return axios.post('api/v1/signature/password', data);
};

export const hasSignPasswordAPI = () => {
    return axios.get('api/v1/signature/signConfig');
};
